import { createAsyncThunk } from "@reduxjs/toolkit";
import { getServerEnvironment } from "../../../constants/staticContents";
export const logoutUser = createAsyncThunk("userSlice/logoutUser", async () => {
  localStorage.removeItem("content-feedback-filters-(Live Database)");
  localStorage.removeItem("content-feedback-filters-(Test Database)");
  localStorage.removeItem("npc-admin-token");
  localStorage.removeItem("npc-admin-userid");
  localStorage.removeItem("npc-admin-permissions");
  localStorage.removeItem("npc-admin-token");
  localStorage.removeItem("copied");
  localStorage.removeItem("p-r-p");
  localStorage.removeItem(btoa(`cf-lists-${getServerEnvironment()}`));
  localStorage.removeItem(btoa(`move-to-cluster-${getServerEnvironment()}`));
  localStorage.removeItem(
    btoa(`content-feedback-filters-${getServerEnvironment()}`)
  );

  localStorage.removeItem(btoa(`p-r-p-${getServerEnvironment()}`));
});
